import { useTranslation } from 'react-i18next'

import { Card } from '@/components/ui/card'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { WeScreen } from '@/components/WeScreen/WeScreen'
import {
  EUserRole,
  EUserPermission,
} from '@/hooks/usePermissions/permissions.type'
import { usePermissions } from '@/hooks/usePermissions/usePermissions'

import { Account } from './components/Account/Account'
import { ReportSettings } from './components/ReportSettings/ReportSettings'

export const Settings = () => {
  const { t } = useTranslation()
  const { hasPermission } = usePermissions()

  return (
    <WeScreen useHeader={false} customViewStyles="p-0">
      <div className="h-full pb-12 lg:pb-0">
        <Card>
          <Tabs defaultValue="account" className="rounded-2xl p-6">
            <TabsList className="w-full bg-transparent justify-start border-b border-primaryColor30 p-0 rounded-none mb-5">
              <TabsTrigger
                value="account"
                className="hover:cursor-pointer w-min max-md:w-full border-x-0 border-t-0 rounded-none bg-transparent data-[state=active]:bg-transparent data-[state=active]:text-primaryColor data-[state=active]:font-bold data-[state=active]:border-b-primaryColor data-[state=active]:shadow-none font-semibold text-neutralColor80 data-[state=inactive]:border-none"
              >
                {t('dashboard.settings.title')}
              </TabsTrigger>
              {hasPermission(
                EUserPermission.HANDLE_REPORTS,
                EUserRole.OWNER,
              ) && (
                <TabsTrigger
                  value="reportSettings"
                  className="hover:cursor-pointer w-min max-md:w-full border-x-0 border-t-0 rounded-none bg-transparent data-[state=active]:bg-transparent data-[state=active]:text-primaryColor data-[state=active]:font-bold data-[state=active]:border-b-primaryColor data-[state=active]:shadow-none font-semibold text-neutralColor80 data-[state=inactive]:border-none"
                >
                  {t('dashboard.settings.reportSettingsTitle')}
                </TabsTrigger>
              )}
            </TabsList>
            <TabsContent value="account">
              <Account />
            </TabsContent>

            <TabsContent value="reportSettings">
              <ReportSettings />
            </TabsContent>
          </Tabs>
        </Card>
      </div>
    </WeScreen>
  )
}
